const getEnvironmentType = (hostname?: string) => {
  if (!hostname) return "development";

  // Extract host from URL or plain host, remove port
  const host = hostname.trim().toLowerCase();

  // If has servicebund-domain
  if (/-qa(?:-[^.]+)?\.servicebund\.com$/.test(host)) return "qa";
  if (/-test(?:-[^.]+)?\.servicebund\.com$/.test(host)) return "test";
  if (/\.servicebund\.com$/.test(host)) return "prod";

  return "development";
};

export type EnvironmentType = ReturnType<typeof getEnvironmentType>;

export default getEnvironmentType;
